import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../services/api";
import Constants from "../../../services/constants";
import { hideLoader, showLoader } from "../loaderSlice";
import { showToast } from "../toastSlice";

const initialState = {
  data: [],
  planList: [],
  userDetails: [],
  billingInfo: [],
  subscibedPlan: "",
};

export const getUserDetails = createAsyncThunk(
  "apiTokens/get",
  async (_, { dispatch }) => {
    try {
      const res = await api("get", Constants.END_POINT.getUserDetails);
      if (res?.success && res?.data) {
        dispatch(setUserDetails(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const updateUser = createAsyncThunk(
  "apiToken/post",
  async ({ data, next = () => null }, { dispatch }) => {
    try {
      const res = await api("post", Constants.END_POINT.updateUser, data);
      if (res?.success && res?.data) {
        // dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getUserDetails());
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const addBillingInfo = createAsyncThunk(
  "apiToken/post",
  async ({ org_id, data, next }, { dispatch }) => {
    try {
      const res = await api(
        "post",
        `${Constants.END_POINT.addBillingInfo}?org_id=${org_id}`,
        data
      );
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const fetchBillingInformation = createAsyncThunk(
  "apiTokens/get",
  async (org_id, { dispatch }) => {
    try {
      const res = await api(
        "get",
        Constants.END_POINT.fetchBillingInfo + "/" + org_id,
        {}
      );

      if (res?.success) {
        dispatch(setBillingInfo(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
    } finally {
    }
  }
);

export const getPlans = createAsyncThunk(
  "apiTokens/get",
  async (_, { dispatch }) => {
    try {
      const res = await api("get", Constants.END_POINT.getPlans, {});
      if (res?.success && res?.data) {
        dispatch(setPlanData(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const buySubscription = createAsyncThunk(
  "apiTokens/create",
  async ({ orgId, planId, next }, { dispatch }) => {
    try {
      const res = await api(
        "post",
        `${Constants.END_POINT.buySubscription}?org_id=${orgId}`,
        {
          planId: planId,
          orgId: orgId,
        }
      );
      if (res?.success && res?.data) {
        dispatch(setSubscription(res?.data?.subscriptionId));
        dispatch(showToast({ severity: "success", summary: res.message }));
        return { id: res?.data?.subscriptionId };
        // next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const paymentActionSubscription = createAsyncThunk(
  "apiTokens/create",
  async ({ orgId, subId, action, type }, { dispatch }) => {
    try {
      const res = await api(
        "delete",
        `${Constants.END_POINT.paymentAction}/${subId}/${orgId}/${action}/${type}`
      );
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "project/get_log",
  async ({ org_id, next }, { dispatch }) => {
    // dispatch(setProjectLogs([]))
    try {
      const res = await api(
        "delete",
        Constants.END_POINT.cancelSubscription + org_id,
        {}
      );
      if (res?.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const chargeCard = createAsyncThunk(
  "apiTokens/create",
  async ({ data, next }, { dispatch }) => {
    try {
      const res = await api("post", Constants.END_POINT.chargeCard, data);
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const upgradeSubscription = createAsyncThunk(
  "apiTokens/patch",
  async ({ orgId, planId, next }, { dispatch }) => {
    try {
      const res = await api("patch", Constants.END_POINT.upgradeSubscription, {
        planId: planId,
        orgId: orgId,
      }); // Change 'post' to 'patch'
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const getSubscription = createAsyncThunk(
  "apiTokens/get",
  async ({ org_id }, { dispatch }) => {
    try {
      const res = await api(
        "get",
        `${Constants.END_POINT.getSubscription}?org_id=${org_id}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setSubscription(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const getApiTokensAction = createAsyncThunk(
  "apiTokens/get",
  async ({ org_id }, { dispatch }) => {
    try {
      const res = await api(
        "get",
        `${Constants.END_POINT.ApiToken}?org_id=${org_id}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setApiTokenData(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const createApiTokensAction = createAsyncThunk(
  "apiTokens/create",
  async ({ desc, org_id, next }, { dispatch }) => {
    try {
      const res = await api("post", Constants.END_POINT.ApiToken, {
        name: desc,
        org_id: org_id,
      });
      if (res?.success && res?.data) {
        dispatch(
          showToast({
            severity: "success",
            summary: "API token created successfully",
            persistent: true, // Security-related - should be added to notifications
          })
        );
        dispatch(getApiTokensAction());
        next(); // Close modal
      } else {
        dispatch(
          showToast({
            severity: "error",
            summary: String(res.message),
            persistent: true, // Security-related error - should be added to notifications
          })
        );
      }
    } catch (error) {
      dispatch(
        showToast({
          severity: "error",
          summary: String(error.message),
          persistent: true, // Security-related error - should be added to notifications
        })
      );
    } finally {
    }
  }
);

export const deleteApiToken = createAsyncThunk(
  "apiTokens/delete",
  async ({ id, org_id }, { dispatch }) => {
    try {
      const res = await api(
        "delete",
        `${Constants.END_POINT.ApiToken}/${id}?org_id=${org_id}`
      );
      if (res?.success && res?.data) {
        dispatch(getApiTokensAction()); // Refresh the tokens list
        dispatch(
          showToast({
            severity: "success",
            summary: String(res?.data?.message?.message),
          })
        );
      } else {
        dispatch(
          showToast({
            severity: "error",
            summary: String(res.message.message),
          })
        );
      }
    } catch (error) {
      dispatch(
        showToast({
          severity: "error",
          summary: String(error.message) || "An error occurred.",
        })
      );
      return Promise.reject(error.message || "An error occurred.");
    } finally {
    }
  }
);

const apiTokenSlice = createSlice({
  name: "apiToken",
  initialState,
  reducers: {
    setApiTokenData: (state, action) => {
      state.data = action.payload;
    },
    setPlanData: (state, action) => {
      state.planList = action.payload;
    },
    setSubscription: (state, action) => {
      state.subscibedPlan = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setBillingInfo: (state, action) => {
      state.billingInfo = action.payload;
    },
  },
});

export const {
  setApiTokenData,
  setPlanData,
  setUserDetails,
  setBillingInfo,
  setSubscription,
} = apiTokenSlice.actions;

export default apiTokenSlice.reducer;
